import { type Locale } from "@/types";
import { addLocaleToPath } from "@/utils/locale/addLocaleToPath";

export function createLocalizedPathList(
  pathname: string,
  primaryLocale: Locale,
  secondaryLocales: Locale[],
  lookupFromPathIndex = 0,
) {
  return [primaryLocale, ...secondaryLocales].map((locale) => ({
    locale,
    path: addLocaleToPath(pathname, locale, primaryLocale, lookupFromPathIndex),
  }));
}
